/**
 * Laughlin Highlands Farm Box Builder safeguards.
 *
 * Keeps the configurable box from advertising a $0 price and prevents an
 * empty box from being added to the cart. This file is intentionally separate
 * from theme.liquid so it can be reviewed and restored during theme updates.
 */
(() => {
  const builderPath = '/apps/boxi/box-builder/3385';
  const builderProductPath = '/products/pasture-raised-box-builder';

  const updateBuilderCards = () => {
    document.querySelectorAll(`a[href^="${builderProductPath}"]`).forEach((link) => {
      const card = link.closest('.card-wrapper, .card');
      const price = card && card.querySelector('.price');

      if (!price || price.dataset.lhfBuilderPrice === 'true') return;

      const regularPrice = price.querySelector('.price__regular .price-item') || price;
      regularPrice.textContent = 'Price calculated from selections';
      price.dataset.lhfBuilderPrice = 'true';
      price.setAttribute('aria-label', 'Price calculated from selections');
    });
  };

  const initBuilderGuard = () => {
    if (window.location.pathname !== builderPath) return;

    const style = document.createElement('style');
    style.textContent = `
      button[data-lhf-box-empty="true"] {
        cursor: not-allowed !important;
        opacity: 0.55 !important;
      }
      [data-lhf-box-total-empty="true"] {
        font-weight: 600;
      }
    `;
    document.head.appendChild(style);

    let updateQueued = false;

    const getTotals = () => {
      const classMatches = Array.from(document.querySelectorAll('[class*="_totalAmount_"]'));
      const semanticMatches = Array.from(document.querySelectorAll('main div')).filter((element) => {
        const label = element.querySelector(':scope > span:first-child');
        return label && label.textContent.trim().toLowerCase() === 'total:';
      });

      return Array.from(new Set([...classMatches, ...semanticMatches]));
    };

    const updateBuilderState = () => {
      updateQueued = false;

      const totals = getTotals();
      const positiveTotal = totals
        .map((element) => element.textContent.match(/Total:\s*(\$[\d,.]+)/i))
        .find((match) => match && Number(match[1].replace(/[$,]/g, '')) > 0);
      const hasSelection = Boolean(positiveTotal);
      const checkoutButtons = Array.from(document.querySelectorAll('button')).filter(
        (button) =>
          button.dataset.lhfBoxGuard === 'true' ||
          button.className.includes('_checkoutButton_') ||
          button.textContent.trim() === 'Add to cart'
      );

      totals.forEach((total) => {
        const amount = total.querySelector('span:last-child') || total;
        const desiredText = hasSelection
          ? positiveTotal[1]
          : 'Select at least 1 item to see your total';

        if (amount.textContent.trim() !== desiredText) amount.textContent = desiredText;
        total.dataset.lhfBoxTotalEmpty = String(!hasSelection);
      });

      checkoutButtons.forEach((button) => {
        button.dataset.lhfBoxGuard = 'true';

        if (!hasSelection) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.dataset.lhfBoxEmpty = 'true';
          if (button.textContent.trim() !== 'Select at least 1 item') {
            button.textContent = 'Select at least 1 item';
          }
        } else if (button.dataset.lhfBoxEmpty === 'true') {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          button.dataset.lhfBoxEmpty = 'false';
          if (button.textContent.trim() !== 'Add to cart') button.textContent = 'Add to cart';
        }
      });
    };

    const queueBuilderUpdate = () => {
      if (updateQueued) return;
      updateQueued = true;
      window.requestAnimationFrame(updateBuilderState);
    };

    new MutationObserver(queueBuilderUpdate).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    queueBuilderUpdate();
  };

  const init = () => {
    updateBuilderCards();
    initBuilderGuard();

    if (window.location.pathname !== builderPath) {
      new MutationObserver(updateBuilderCards).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
